<template>
  <div class="flex items-center px-1" :class="{ 'money-amount money-amount--primary': variant === 'primary' }">
    <!-- Se rendea la parte numérica con Intl.NumberFormat().formatToParts() en
         vez de <i18n-n> con slots por-parte: bajo vue-i18n 9 esos slots (#integer
         /#fraction/...) NO se disparan cuando :format es un objeto inline sin
         `key` -> el número salía como texto plano y se perdía numberStyle (el
         monto grande de "Destinatario recibe"/"Recibirás") y la fracción a 0.8em.
         Acá se replica exactamente el estilo original por tipo de parte. -->
    <div class="flex items-baseline money-amount__number">
      <template v-for="(part, i) in numberParts" :key="i">
        <div v-if="part.type === 'integer'" class="money-amount__integer" :style="variant === 'primary' ? null : numberStyle">{{ part.value }}</div>
        <span v-else-if="part.type === 'fraction'" class="money-amount__fraction" :style="variant === 'primary' ? null : numberStyle + ' font-size: 0.8em'">{{ part.value }}</span>
        <span v-else :class="'money-amount__' + part.type">{{ part.value }}</span>
      </template>
    </div>
    <div :style="variant === 'primary' ? null : numberStyle" class="pl-1 money-amount__currency">{{ currencyUpperCase }}</div>
  </div>
</template>
<script>
export default {
  name: "FormatAmount",
  props: {
    variant: {
      type: String,
      default: ""
    },
    amount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    minimumFractionDigits: {
      type: Number,
      default: 0
    },
    maximumFractionDigits: {
      type: Number,
      default: 0
    },
    hideZeroDecimals: {
      type: Boolean,
      default: false
    },
    numberStyle: {
      type: String,
      default: ""
    }
  },
  computed: {
    // Partes del número (integer/group/decimal/fraction) en el locale activo.
    // Mismas opciones que usaba el <i18n-n> anterior, así los VALORES no cambian;
    // solo se recupera el control del estilo por-parte que vue-i18n 9 rompió.
    numberParts() {
      const locale = (this.$i18n && this.$i18n.locale) || "es";
      const value = Number(this.amount);
      const num = Number.isFinite(value) ? value : 0;
      try {
        const parts = new Intl.NumberFormat(locale, {
          style: "decimal",
          useGrouping: true,
          maximumFractionDigits: this.maximumFractionDigits,
          minimumFractionDigits: this.minimumFractionDigits
        }).formatToParts(num);
        // Inspect the displayed fraction after Intl rounding: keep 10.50, but
        // hide .00 (including a value that rounds to a whole displayed amount).
        if (this.hideZeroDecimals && parts.some(part => part.type === "fraction" && /^0+$/.test(part.value))) {
          return parts.filter(part => part.type !== "decimal" && part.type !== "fraction");
        }
        return parts;
      } catch (e) {
        return [{ type: "integer", value: String(num) }];
      }
    },
    currencyUpperCase() {
      // Fail-visibly (regla fintech: nunca mostrar dinero sin su código de
      // moneda). Un monto distinto de cero SIN moneda es un bug de datos aguas
      // arriba; mostramos "?" para que el usuario no confíe en un número sin
      // unidad. Con monto 0 (estado de carga / sin tasa) no ensuciamos la UI.
      if (!this.currency) {
        return this.amount ? "?" : "";
      }
      return this.currency.toUpperCase();
    }
  }
};
</script>
